// extracted by mini-css-extract-plugin
export default {"columns":"DomainSuggest-columns_Suw3h","filters":"DomainSuggest-filters_hN49b","domains":"DomainSuggest-domains_y_P3R","provided":"DomainSuggest-provided_F3DzG"};